import React from "react";
import { Button, Card, CardHeader, CardText, Carousel, CarouselItem, Collapse, ListGroup, ListGroupItem } from 'react-bootstrap';
// import react-redux
import { useDispatch } from "react-redux";
import { REMOVE_FROM_CART, UPDATE_CART_QUANTITY } from "./utils/actions";
import { idbPromise } from "./utils/helpers.js";

const CartItem = ({ item }) => {
  console.log(item)
  // create dispatch object from useDispatch()
  const dispatch = useDispatch();

  //! since the item is being passed in as a prop from cart component with "state.cart.map((item).... <CartItem item='item'/>" we dont need state
    // // create state object from useSelector()
      // const state = useSelector((s) => s);

  const removeFromCart = (item) => {
    dispatch({
      type: REMOVE_FROM_CART,
      _id: item._id,
      size: item.size
    });
    idbPromise("cart", "delete", { ...item });
  };

 const updateQuantity = (newQty) => {
  if (newQty <= 0) {
    dispatch({
      type: REMOVE_FROM_CART,
      _id: item._id,
      size: item.size,
    });
    idbPromise("cart", "delete", { ...item });
  } else {
    dispatch({
      type: UPDATE_CART_QUANTITY,
      _id: item._id,
      size: item.size,
      purchaseQuantity: newQty,
    });
    idbPromise("cart", "put", { ...item, purchaseQuantity: newQty });
  }
};

  return (
    <div >
      {/* <div className='cart-item__image'>
        <img src={`/images/${item.image[0]}`} alt="" />
      </div> */}
      <Card className="card-body-product-expand"
        style={{
        // width: '50%',
        // height: '50%',
        marginTop: '2%',
        marginRight: '5%',
        marginLeft: '5%',
        marginBottom: '1%',
        color:'white'
        }}>
      
        <div >
        <div className="cart-item__name-price">
          <h5>
          {item.name}
          </h5>
        </div>
         <div className="cart-item__name-price">
          {/* <p>
          {item.details}
          </p> */}
        </div>
        <div className="cart-item__name-price">
          <h5>
          
               ${item.price}
     
           
          </h5>
        </div>
        <div className="cart-item__size" >
          
          <h5>
            Size : {item.size}
          </h5>
       
        </div>
        <div className="cart-item__quantity">
        <h5>Qty</h5>
        <h5>{item.purchaseQuantity}</h5>
        </div>
<div className="cart-item__quantity">
<Button
  className="process-card-text hover-brighten-red"
  onClick={() => updateQuantity(item.purchaseQuantity - 1)}
  style={{
    backgroundColor: 'rgb(200, 0, 0)',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    margin: '0 5px',
    width: '25px',
    height: '25px',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    fontWeight: 'bold',
    padding: 0,
  }}
>
  <h5 style={{ margin: '1%' }} >
     −
  </h5>
</Button>
<Button
  className="process-card-text hover-brighten-green"
  onClick={() => updateQuantity(item.purchaseQuantity + 1)}
  style={{
    backgroundColor: 'rgb(0, 128, 0)',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    margin: '0 5px',
    width: '25px',
    height: '25px',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    fontWeight: 'bold',
    padding: 0,
  }}
>
  <h5 style={{ margin: '1%' }}>
     +
  </h5>
</Button>
          {/* <span
          className="cart-item__delete"
            role="img"
            aria-label="trash"
            onClick={() => removeFromCart(item)}
          >
            🗑️
          </span> */}
        </div>
      </div>


      </Card>

    </div>
  );
};

export default CartItem;

